import React from 'react';
import Select from 'react-select';
import {gitExtProjectUrl} from "./constants";

const YML = "Yml";
const XML = "Xml";

function createDemoOptions(demoNames){
    return demoNames.map(demoName => {
        return { value : demoName, label : demoName.charAt(0).toUpperCase() + demoName.slice(1)}
    });
}

function getDemoNames(response){
    return [...new Set(response.map(obj => obj["name"].split('.')[0]))];
}

class DemoSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: null,
            nbDemo: 0,
            demoNames: []
        };

        this.fetchResources = this.fetchResources.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        var url = gitExtProjectUrl + '/repository/tree?path=demo';
        fetch(url)
            .then((response) => response.json())
            .then((json) => {
                this.setState({
                    nbDemo: json.length/2,
                    demoNames: getDemoNames(json)
                });
            });

    }

    async fetchResources(selectedOption){
        await this.fetchLocalResource(gitExtProjectUrl + '/repository/files/demo%2f' + selectedOption.value + '.yml/raw?ref=master', YML);
        await this.fetchLocalResource(gitExtProjectUrl + '/repository/files/demo%2f' + selectedOption.value + '.xml/raw?ref=master', XML);
    }

    fetchLocalResource(url, extension){
        return fetch(url)
            .then(function(response){
                return response.text();
            })
            .then( data => {
                switch(extension){
                    case YML : this.props.handleConfig(data, false); break;
                    case XML: this.props.handleInput(data, false); break;
                    //no default
                }
            });
    }


    async handleChange(selectedOption){
        this.setState({ selectedOption });
        await this.fetchResources(selectedOption);
        this.props.autoSubmit();
    };

    render() {
        const { selectedOption } = this.state;
        return (
            <Select
                value={selectedOption}
                onChange={this.handleChange}
                options={createDemoOptions(this.state.demoNames)}
                placeholder={"Select a demo ..."}
            />
        );
    }
}

export default DemoSelect;